import React from 'react'
export default function VpnBlocked({ className, style }) {
  return (
    <svg className={className} width="1em" height="1em" style={{ verticalAlign: '-0.125em', ...style }}
      viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth="1.6"
      strokeLinecap="round" strokeLinejoin="round">
      <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      <text x="12" y="12.4" textAnchor="middle" fontSize="5.2" fontWeight="800" fill="currentColor" stroke="none">VPN</text>
      <circle cx="18.6" cy="18.6" r="4" fill="#fff" stroke="#e5484d" strokeWidth="1.6" />
      <path d="M15.8 15.8 21.4 21.4" stroke="#e5484d" strokeWidth="1.6" />
    </svg>
  )
}
